import React from 'react';
import './index.scss';

import {
  CONF_URL,
  BUTTON_NO_PREV,
  BUTTON_DEFAULT,
  BUTTON_SUBMIT,
  BUTTON_BACKLP,
} from 'utils/constant';

import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import NextButton from 'components/atoms/Button/NextButton';
import PrevButton from 'components/atoms/Button/PrevButton';
import BackLpButton from 'components/atoms/Button/BackLpButton';

const empty = () => {};

const PcButtonArea = ({
  onClickMainButton = {},
  isModify,
  prevUrl,
  nextUrl,
  buttonType,
  valid,
  lpMode,
}) => {

  const prevClick = onClickMainButton.prev ? (e) => onClickMainButton.prev(e) : empty;
  const nextClick = onClickMainButton.next ? (e) => onClickMainButton.next(e) : empty;
  
  // 標準のボタン
  const PFDfaultButton = () => (
    <>
      <div className="prev">
        <PrevButton link={prevUrl} onClick={prevClick} />
      </div>
      <div className="next">
        <NextButton label='次へ' link={nextUrl} onClick={nextClick} valid={valid} />
      </div>
    </>
  );

  // 次へのみのボタン
  const PFNoPrevButton = () => (
    <div className="nextOnly">
      <NextButton label='次へ' link={nextUrl} onClick={nextClick} valid={valid} />
    </div>
  );

  // 送信ボタン
  const PFSubmitButton = () => (
    <>
      <div className="prev">
        <PrevButton link={prevUrl} onClick={prevClick} />
      </div>
      <div className="next">
        <ClickOnlyButton label='下記に同意して依頼する' onClick={nextClick} isShowMark />
        <div className="privacy-pollicy">
          <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
          ・
          <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
          {' '}
          にご同意いただいたうえで送信してください。
        </div>
      </div>
    </>
  );

  // LPに戻るボタン
  const PFBackLpButton = () => (
    <>
      {!lpMode && (
        <div className="backLp">
          <BackLpButton label='戻る' link="" onClick={nextClick} />
        </div>
      )}
    </>
  );

  // 修正モード中のボタン
  const PFModifyModeButton = () => (
    <div className="nextOnly">
      <NextButton label='確認画面へ' link={CONF_URL} onClick={nextClick} valid={valid} />
    </div>
  );

  const FooterButtons = {
    [BUTTON_DEFAULT]: isModify ? <PFModifyModeButton /> : <PFDfaultButton />,
    [BUTTON_NO_PREV]: isModify ? <PFModifyModeButton /> : <PFNoPrevButton />,
    [BUTTON_SUBMIT]: <PFSubmitButton />,
    [BUTTON_BACKLP]: <PFBackLpButton />,
  };

  return (
    <div className="PcButtonArea" id="FooterButtons">
      <div className="wrapper">
        <div className="button-wrapper">
          {FooterButtons[buttonType]}
        </div>
      </div>
    </div>
  );
};

export default PcButtonArea;